import './About.css';

import * as Icon from 'react-bootstrap-icons';
import ProfilePic from './assets/NicklasBehrndtz_Billede_Kvadrat.png';
import ButtonHollow from './components/ButtonHollow.js';
import ButtonHome from './components/ButtonHome.js';

import { lazy, Suspense } from 'react';
import ViewportLoader from './components/ViewportLoader.js';

const Header = lazy(() => import('./AboutHeader.js'))
const Education = lazy(() => import('./AboutEducation.js'))
const Skills = lazy(() => import('./AboutSkills.js'))
const Portfolio = lazy(() => import('./AboutPortfolio.js'))
const Footer = lazy(() => import('./Footer.js'))

const About = () =>
{
  return (
    <>
      <Suspense>
      {/* <ViewportLoader height={"80vh"} color='blue'> */}
      <Header />
      {/* </ViewportLoader> */}
      </Suspense>

      <Suspense>
      {/* <ViewportLoader height="1200px" viewMargin='400px'> */}
      <div id='education'>
        <Education />
      </div>
      {/* </ViewportLoader> */}
      </Suspense>

      <Suspense>
      {/* <ViewportLoader height="840px" color='rgb(0, 121, 121)' viewMargin='400px'> */}
      <div id='skills'>
      <Skills />
      </div>
      {/* </ViewportLoader> */}
      </Suspense>

      <Suspense>
      {/* <ViewportLoader height="80vh" viewMargin='400px'> */}
      <div id='portfolio'>
      <Portfolio />
      </div>
      {/* </ViewportLoader> */}
      </Suspense>

      <Suspense>
      {/* <ViewportLoader height="30vh" viewMargin='400px'> */}
      <Footer />
      {/* </ViewportLoader> */}
      </Suspense>

      {/* Section buttons */}
      <div className='shortcut-menu d-none d-xl-flex flex-column'>
        <h4 style={{color: 'var(--brightYellow)', marginBottom: '1rem'}}>sections</h4>
        <a className='btn-text' href='#top'>TOP</a>
        <a className='btn-text' href='#education'>EDUCATION</a>
        <a className='btn-text' href='#skills'>SKILLS</a>
        <a className='btn-text' href='#portfolio'>PORTFOLIO</a>
      </div>
    </>
  )
}

export default About